module.exports = (__webpack_require__("bricks/presentational-bricks:XuQu"))("J4zp");